import angular from 'angular';

module.exports = angular.module('market.component.od-repair-item', [])
.directive('odRepairItem', function() {
  return {
    restrict: 'E',
    scope: {
      item: '=',
    },
    template: require('./od-repair-item.jade')(),
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-repair-item.js
 **/